import { lazy } from 'react';
import PATH from 'routes/paths';
import { Route } from 'routes/types';

const ConnectedBusinessExperienceViewOnePage = lazy(
  () =>
    import(
      '../../components/smart/pages/businessPages/experience/ConnectedBusinessExperienceViewOnePage'
    )
);

const ConnectedWaitingListPage = lazy(
  () =>
    import(
      '../../components/smart/pages/businessPages/experience/ConnectedWaitingListPage'
    )
);

const ConnectedBusinessMindFeed = lazy(
  () =>
    import(
      '../../components/smart/pages/businessPages/mindFeed/ConnectedBusinessMindFeedPage'
    )
);

const ConnectedBusinessMindFeedByExperience = lazy(
  () =>
    import(
      '../../components/smart/pages/businessPages/mindFeed/ConnectedMindFeedByExperiencePage'
    )
);
const ConnectedMindFeedFavoritesPage = lazy(
  () =>
    import(
      '../../components/smart/pages/businessPages/mindFeed/ConnectedMindFeedFavorites'
    )
);

const EXPERIENCE_VIEW_ONE: Route = {
  component: ConnectedBusinessExperienceViewOnePage,
  path: PATH.BUSINESS.EXPERIENCE_VIEW_ONE,
  isProtected: false,
  hasMenuBar: false,
};

const EXPERIENCE_WAITING_LIST: Route = {
  component: ConnectedWaitingListPage,
  path: PATH.BUSINESS.WAITING_LIST,
  isProtected: true,
  hasMenuBar: false,
};

const MIND_FEED: Route = {
  component: ConnectedBusinessMindFeed,
  path: PATH.BUSINESS.MIND_FEED,
  isProtected: true,
  hasMenuBar: true,
};

const MIND_FEED_BY_EXPERIENCE: Route = {
  component: ConnectedBusinessMindFeedByExperience,
  path: PATH.BUSINESS.MIND_FEED_BY_EXPERIENCE,
  isProtected: true,
  hasMenuBar: true,
};

const MIND_FEED_FAVORITES: Route = {
  component: ConnectedMindFeedFavoritesPage,
  path: PATH.BUSINESS.MIND_FEED_FAVORITES,
  isProtected: true,
  hasMenuBar: true,
};

export default [
  EXPERIENCE_VIEW_ONE,
  EXPERIENCE_WAITING_LIST,
  MIND_FEED,
  MIND_FEED_BY_EXPERIENCE,
  MIND_FEED_FAVORITES,
];
